
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("JQEJY", function(module, exports) {

$parcel$export(module.exports, "PageCatchupComponent", () => $f625d855ba7548b9$export$c463287b61deee24);
$parcel$export(module.exports, "PageCatchupPopupForPageHistory", () => (parcelRequire("86vQj")).PageCatchupPopupForPageHistory);

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $9PrGG = parcelRequire("9PrGG");

var $jmjWc = parcelRequire("jmjWc");

var $gL2Cx = parcelRequire("gL2Cx");

var $86vQj = parcelRequire("86vQj");
const $f625d855ba7548b9$var$AISummarizeButtonPlaceholderWithText = ()=>{
    const intl = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9PrGG.AISummarizeButtonPlaceholder), {
        summarizeText: intl.formatMessage((0, $gL2Cx.i18n).catchUpButtonText)
    });
};

const $f625d855ba7548b9$export$c463287b61deee24 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "DS85o",
    name: "PageCatchupComponent",
    loader: async ()=>(await Promise.resolve((parcelRequire("4RbVT")))).PageCatchupComponentWithErrorBoundary
});

const $f625d855ba7548b9$export$b8934fe6f5a65359 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ZVEMJ",
    name: "PageCatchupPopup",
    loader: async ()=>(await Promise.resolve((parcelRequire("gL2Cx")))).PageCatchupPopupComponent,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($f625d855ba7548b9$var$AISummarizeButtonPlaceholderWithText, null)
});

});
parcelRegister("gL2Cx", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $3d9eb45e9938578d$export$a7357cdd1f0b0168);
$parcel$export(module.exports, "PageCatchupPopupComponent", () => $3d9eb45e9938578d$export$93a2b98265b32e4b);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $lGgRw = parcelRequire("lGgRw");

var $ccHMk = parcelRequire("ccHMk");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $inPa6 = parcelRequire("inPa6");

var $3gadb = parcelRequire("3gadb");

var $ly2zj = parcelRequire("ly2zj");

var $4RbVT = parcelRequire("4RbVT");

var $kBab3 = parcelRequire("kBab3");
const $3d9eb45e9938578d$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    catchUpButtonText: {
        id: "page-catchup.catchup.button.text",
        defaultMessage: "Summarize differences"
    }
});
const $3d9eb45e9938578d$var$ContentWidthStyles = (0, $ecnYn.xcss)({
    width: '500px'
});
const $3d9eb45e9938578d$export$93a2b98265b32e4b = ({ contentId: contentId, contentType: contentType, spaceKey: spaceKey, source: source, isDisabled: isDisabled, selectedVersions: selectedVersions })=>{
    const [isOpen, setIsOpen] = (0, $gwFzn.useState)(false);
    const intl = (0, $dBxQj.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $kBab3.usePageCatchupQueryParamOpen)(isOpen, setIsOpen, selectedVersions);
    const onClick = ()=>{
        setIsOpen(!isOpen);
        if (!isOpen) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'pageCatchup',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'pageCatchupButton',
                attributes: {
                    contentId: contentId,
                    source: source
                }
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lGgRw.default), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        popupComponent: (0, $ly2zj.CustomPopupContainer),
        shouldFlip: false,
        shouldRenderToParent: true,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
                xcss: $3d9eb45e9938578d$var$ContentWidthStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4RbVT.PageCatchupComponentWithErrorBoundary), {
                contentId: contentId,
                contentType: contentType,
                spaceKey: spaceKey,
                source: source,
                selectedVersions: selectedVersions
            })),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
                hideTooltipOnMouseDown: true,
                position: "bottom",
                content: intl.formatMessage($3d9eb45e9938578d$export$a7357cdd1f0b0168.catchUpButtonText)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
                ...triggerProps,
                "aria-haspopup": "dialog",
                onClick: onClick,
                isSelected: isOpen,
                iconBefore: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ly2zj.AIButtonIcon), {
                        label: ""
                    }),
                "aria-label": intl.formatMessage($3d9eb45e9938578d$export$a7357cdd1f0b0168.catchUpButtonText),
                isDisabled: isDisabled
            }, intl.formatMessage($3d9eb45e9938578d$export$a7357cdd1f0b0168.catchUpButtonText)))
    });
};

});
parcelRegister("4RbVT", function(module, exports) {

$parcel$export(module.exports, "PageCatchupComponentWithErrorBoundary", () => $82cc03f71f27d09d$export$22f83c0ec7a66a2);

var $gwFzn = parcelRequire("gwFzn");

var $2Rith = parcelRequire("2Rith");

var $dIouf = parcelRequire("dIouf");

var $9wGTI = parcelRequire("9wGTI");

var $4K3mj = parcelRequire("4K3mj");

var $a9eQ6 = parcelRequire("a9eQ6");
const $82cc03f71f27d09d$export$22f83c0ec7a66a2 = (props)=>{
    const aiAnalyticsConfig = {
        product: 'confluence',
        subproduct: 'confluence',
        source: props.source ?? 'confluencePage',
        aiFeatureName: 'pageCatchup',
        proactiveGeneratedAI: 0,
        userGeneratedAI: 1
    };
    const hasSelectedVersions = props.selectedVersions && props.selectedVersions.size > 1 && props.source === 'pageHistory';
    const pageCatchupComponent = hasSelectedVersions && (0, $9wGTI.fg)('confluence_ai_page_catchup_convo_ai_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $a9eQ6.PageCatchupVersionDiffWrapperComponent), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4K3mj.PageCatchupStreamingComponent), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).SMARTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Rith.AIEventsInstrumentationProvider), {
        config: aiAnalyticsConfig
    }, pageCatchupComponent));
};

});
parcelRegister("4K3mj", function(module, exports) {

$parcel$export(module.exports, "PageCatchupStreamingComponent", () => $68e47fc55df08327$export$4c578b92894b49da);
/* PageCatchupStreamingComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @graphql cc
 */ 
var $35pXk = parcelRequire("35pXk");

var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $diswb = parcelRequire("diswb");

var $kyKWe = parcelRequire("kyKWe");

var $inPa6 = parcelRequire("inPa6");

var $gdv5Z = parcelRequire("gdv5Z");

var $3j1mV = parcelRequire("3j1mV");

var $fXbFR = parcelRequire("fXbFR");

var $fYQcF = parcelRequire("fYQcF");

var $dOOm2 = parcelRequire("dOOm2");
var $au4KV = parcelRequire("au4KV");
var $8LJEA = parcelRequire("8LJEA");

var $ioNzo = parcelRequire("ioNzo");
var $ar5A7 = parcelRequire("ar5A7");

var $ly2zj = parcelRequire("ly2zj");

var $bQm3c = parcelRequire("bQm3c");

var $dIouf = parcelRequire("dIouf");

var $irVI7 = parcelRequire("irVI7");
var $1eaCJ = parcelRequire("1eaCJ");
var $1kHsc = parcelRequire("1kHsc");

var $dPJCf = parcelRequire("dPJCf");

var $6mKj3 = parcelRequire("6mKj3");

var $jZjxH = parcelRequire("jZjxH");

var $41usS = parcelRequire("41usS");

var $ifEd5 = parcelRequire("ifEd5");

var $3nYmf = parcelRequire("3nYmf");

var $2XwAb = parcelRequire("2XwAb");

var $555yk = parcelRequire("555yk");

var $5HlWa = parcelRequire("5HlWa");
const $68e47fc55df08327$var$PageCatchupWrapperComponentPageCatchupMetadataQuery = (0, $d2LG0.default)`query PageCatchupStreamingComponentMetadataQuery($contentId:ID!$contentType:CatchupContentType!$endTimeMs:Long!){catchupEditMetadataForContent(contentId:$contentId contentType:$contentType endTimeMs:$endTimeMs){lastVisitTimeISO hasVersionChangedSinceLastVisit users{displayName profilePicture{path}}}content(id:$contentId){nodes{version{number}}}}`;
const $68e47fc55df08327$var$PageCatchupWrapperComponentPageCatchupVersionDiffMetadataForContentQuery = (0, $d2LG0.default)`query PageCatchupStreamingComponentVersionDiffMetadataForContentQuery($contentId:ID!$contentType:CatchupContentType!$originalContentVersion:Int!$revisedContentVersion:Int!){catchupVersionDiffMetadataForContent(contentId:$contentId contentType:$contentType originalContentVersion:$originalContentVersion revisedContentVersion:$revisedContentVersion){isDiffEmpty users{displayName profilePicture{height isDefault width path}}}}`;
const $68e47fc55df08327$var$useOpenContentCatchupParam = (0, $dPJCf.createSingleQueryParamHook)('openContentCatchup'); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/design-system/use-tokens-typography
const $68e47fc55df08327$var$styles = null;
const $68e47fc55df08327$export$4c578b92894b49da = ({ contentId: contentId, contentType: contentType, spaceKey: spaceKey, source: source, selectedVersions: selectedVersions, isInObjectSidebar: isInObjectSidebar })=>{
    const { locale: locale } = (0, $dBxQj.default)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { pageAri: pageAri } = (0, $3j1mV.useConfluencePageAri)(cloudId, contentId, contentType);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [aiInteractionId] = (0, $gwFzn.useState)((0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))());
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const catchUpContentRef = (0, $gwFzn.useRef)(null);
    const { getDwellTime: getDwellTime } = (0, $fXbFR.usePopupDwellTime)(catchUpContentRef);
    const [dateInMs] = (0, $gwFzn.useState)(Date.now());
    const [hideMetadata, setHideMetadata] = (0, $gwFzn.useState)(true);
    const { inlineLinkingContent: inlineLinkingContent, updateBuffer: updateBuffer, lastProcessedLength: lastProcessedLength, setLastProcessedLength: setLastProcessedLength } = (0, $ly2zj.useInlineLinkingStreaming)();
    const analyticsProperties = {
        source: 'pageCatchup',
        additionalAnalyticsAttributes: {
            subSource: source
        }
    };
    const originalContentVersion = selectedVersions ? Math.min(...Array.from(selectedVersions)) : 0;
    const revisedContentVersion = selectedVersions ? Math.max(...Array.from(selectedVersions)) : 0;
    const hasSelectedVersions = selectedVersions && selectedVersions.size > 1 && source === 'pageHistory';
    const isStreamingDone = (0, $gwFzn.useRef)(false);
    const isStreamInitializationDone = (0, $gwFzn.useRef)(false);
    const timeToFirstAnswerPart = (0, $gwFzn.useRef)(0);
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultView: trackAIResultView, trackAIResultError: trackAIResultError, trackAIResultAction: trackAIResultAction, trackAIInteractionDismiss: trackAIInteractionDismiss } = (0, $fYQcF.useAIEventsInstrumentation)();
    const hasQueryParamOpenSet = $68e47fc55df08327$var$useOpenContentCatchupParam() === 'true';
    const contentTypeEnum = contentType === 'page' ? (0, $ifEd5.CatchupContentType).PAGE : (0, $ifEd5.CatchupContentType).BLOGPOST;
    const { data: data, error: defaultMetaDataError } = (0, $diswb.useQuery)($68e47fc55df08327$var$PageCatchupWrapperComponentPageCatchupMetadataQuery, {
        variables: {
            contentId: contentId,
            contentType: contentTypeEnum,
            endTimeMs: dateInMs
        },
        skip: hasSelectedVersions
    });
    const { data: versionDiffMetadata, error: versionDiffMetadataError } = (0, $diswb.useQuery)($68e47fc55df08327$var$PageCatchupWrapperComponentPageCatchupVersionDiffMetadataForContentQuery, {
        variables: {
            contentId: contentId,
            contentType: contentTypeEnum,
            originalContentVersion: originalContentVersion,
            revisedContentVersion: revisedContentVersion
        },
        skip: !hasSelectedVersions
    });
    const metaDataError = defaultMetaDataError || versionDiffMetadataError;
    const isVersionDiffEmpty = versionDiffMetadata?.catchupVersionDiffMetadataForContent?.isDiffEmpty ?? false;
    const versionDiffUsers = versionDiffMetadata?.catchupVersionDiffMetadataForContent?.users ?? [];
    const versionDiffEditors = (0, $3nYmf.mapToEditors)(versionDiffUsers);
    const setIsStreamingDone = ()=>{
        isStreamingDone.current = true;
    };
    const setIsStreamInitializationDone = ()=>{
        isStreamInitializationDone.current = true;
    };
    const onShowMoreClick = (0, $gwFzn.useCallback)(()=>{
        trackAIResultAction('showMoreClicked');
    }, [
        trackAIResultAction
    ]);
    let agentNamedId = 'content_catchup_agent';
    let updateType = 'SINCE_LAST_VIEWED_MARKDOWN';
    if (hasSelectedVersions) {
        agentNamedId = 'content_catchup_version_diff_agent';
        updateType = 'BETWEEN_VERSIONS';
    } else if ((0, $6mKj3.expValEqualsNoExposure)('cc_ai_consumption_pc_streaming_inline_linking', 'cohort', 'inline_linking_stream')) {
        agentNamedId = 'content_catchup_streaming_inline_linking_agent';
        updateType = 'SINCE_LAST_VIEWED_MARKDOWN';
    }
    const request = (0, $gwFzn.useMemo)(()=>({
            recipient_agent_named_id: agentNamedId,
            agent_input_context: {
                content_ari: pageAri ?? '',
                locale: locale,
                end_time_ms: dateInMs,
                update_type: updateType,
                ...hasSelectedVersions && {
                    original_content_version: Math.min(...Array.from(selectedVersions)),
                    revised_content_version: Math.max(...Array.from(selectedVersions))
                }
            }
        }), [
        agentNamedId,
        pageAri,
        locale,
        dateInMs,
        updateType,
        hasSelectedVersions,
        selectedVersions
    ]);
    const onStateChange = (0, $gwFzn.useCallback)((state)=>{
        switch(state.responseState){
            case (0, $ioNzo.AIAgentResponseState).Initialization:
                if (state.content === null) {
                    experienceTracker.start({
                        name: (0, $irVI7.AI_CONTENT_CATCHUP_EXPERIENCE)
                    });
                    (0, $555yk.AI_CONTENT_CATCHUP_INTERACTION_METRIC).start();
                    trackAIInteractionInit();
                    timeToFirstAnswerPart.current = Date.now();
                }
                break;
            case (0, $ioNzo.AIAgentResponseState).Error:
                const { status_code: status_code, message_template: message_template } = state.error.message;
                (0, $555yk.AI_CONTENT_CATCHUP_INTERACTION_METRIC).stop();
                trackAIResultError({
                    aiErrorCode: status_code,
                    aiErrorMessage: message_template
                });
                setIsStreamingDone();
                break;
            case (0, $ioNzo.AIAgentResponseState).AnswerPart:
                if (!isStreamInitializationDone.current) {
                    setIsStreamInitializationDone();
                    createAnalyticsEvent({
                        type: 'sendTrackEvent',
                        data: {
                            action: 'streamReceived',
                            actionSubject: 'pageCatchup',
                            source: source ?? 'page',
                            actionSubjectId: 'pageCatchupDialog',
                            attributes: {
                                contentId: contentId,
                                timeToFirstAnswerPartInMs: Date.now() - timeToFirstAnswerPart.current,
                                agentNamedId: agentNamedId
                            }
                        }
                    }).fire();
                }
                const fullContent = (0, $jZjxH.mapInlineLinkingAgentResponseToMarkdown)(state.content);
                const newContent = fullContent.slice(lastProcessedLength);
                updateBuffer(newContent);
                setLastProcessedLength(fullContent.length);
                break;
            case (0, $ioNzo.AIAgentResponseState).FinalResponse:
                (0, $555yk.AI_CONTENT_CATCHUP_INTERACTION_METRIC).stop();
                createAnalyticsEvent({
                    type: 'sendScreenEvent',
                    data: {
                        name: 'pageCatchupDialog',
                        attributes: {
                            contentId: contentId,
                            aiInteractionId: aiInteractionId,
                            hasQueryParamOpenSet: hasQueryParamOpenSet
                        }
                    }
                }).fire();
                trackAIResultView();
                setIsStreamingDone();
                break;
            default:
                break;
        }
    }, [
        trackAIResultError,
        lastProcessedLength,
        updateBuffer,
        setLastProcessedLength,
        createAnalyticsEvent,
        contentId,
        aiInteractionId,
        hasQueryParamOpenSet,
        trackAIResultView,
        experienceTracker,
        trackAIInteractionInit,
        agentNamedId,
        source
    ]);
    const [{ content: content, responseState: responseState, error: streamSummaryError }] = (0, $ar5A7.useAIAgentStreaming)(request, {
        enablePartialJson: (0, $6mKj3.expValEqualsNoExposure)('cc_ai_consumption_pc_streaming_inline_linking', 'cohort', 'inline_linking_stream'),
        delayChunkUpdate: {
            gap: 10,
            time: 20
        },
        headers: {
            'x-experience-id': 'content-catchup',
            'x-product': 'confluence'
        }
    }, onStateChange);
    (0, $gwFzn.useEffect)(()=>{
        if (responseState === (0, $ioNzo.AIAgentResponseState).FinalResponse) {
            if (hideMetadata) setHideMetadata(false);
            if (source !== 'pageHistory') (0, $6mKj3.manuallyLogExpExposure)('cc_ai_consumption_pc_streaming_inline_linking');
        }
    }, [
        responseState,
        hideMetadata,
        source
    ]);
    const handleContainerClick = (0, $gwFzn.useCallback)((e)=>{
        const target = e.target;
        const linkElement = target.closest('a[id="#page-catchup-text-fragment"]');
        if (linkElement) trackAIResultAction('inlineLinkClicked');
    }, [
        trackAIResultAction
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (responseState === (0, $ioNzo.AIAgentResponseState).FinalResponse && (0, $6mKj3.expValEqualsNoExposure)('cc_ai_consumption_pc_streaming_inline_linking', 'cohort', 'inline_linking_stream')) {
            const container = document.querySelector('div[data-testid="ai-border-container"]');
            if (container) {
                container.addEventListener('click', handleContainerClick);
                return ()=>{
                    container.removeEventListener('click', handleContainerClick);
                };
            }
        }
    }, [
        responseState,
        handleContainerClick
    ]);
    (0, $gwFzn.useEffect)(()=>{
        return ()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'dwelled',
                    actionSubject: 'pageCatchup',
                    source: source ?? 'page',
                    actionSubjectId: 'pageCatchupDialog',
                    attributes: {
                        contentId: contentId,
                        dwellTime: getDwellTime(),
                        aiInteractionId: aiInteractionId,
                        hasQueryParamOpenSet: hasQueryParamOpenSet
                    }
                }
            }).fire();
            if (!isStreamInitializationDone.current) trackAIInteractionDismiss({
                attributes: {
                    dismissTiming: 'stream_initialization'
                }
            });
            else if (!isStreamingDone.current) trackAIInteractionDismiss({
                attributes: {
                    dismissTiming: 'answer_part_streaming'
                }
            });
        }; // we only want to run this effect on un-mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const lastVisitedOnDate = (0, $2XwAb.mapToFormattedDate)(data?.catchupEditMetadataForContent?.lastVisitTimeISO, locale);
    const hasVersionChangedSinceLastVisit = data?.catchupEditMetadataForContent?.hasVersionChangedSinceLastVisit ?? false;
    const users = data?.catchupEditMetadataForContent?.users ?? [];
    const defaultEditors = (0, $3nYmf.mapToEditors)(users);
    const editors = source === 'pageHistory' ? versionDiffEditors : defaultEditors;
    const pageVersion = data?.content?.nodes?.[0]?.version?.number ?? -1;
    const { versionHistoryLink: versionHistoryLink } = (0, $5HlWa.useGetVersionHistoryLink)(contentId, spaceKey, pageVersion);
    const onVersionHistoryLinkClick = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'pageCatchup',
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: 'pageCatchupVersionHistoryLink',
                attributes: {
                    contentId: contentId,
                    aiInteractionId: aiInteractionId,
                    hasQueryParamOpenSet: hasQueryParamOpenSet
                }
            }
        }).fire();
        trackAIResultAction('versionHistoryLinkClick');
    }, [
        contentId,
        createAnalyticsEvent,
        aiInteractionId,
        hasQueryParamOpenSet,
        trackAIResultAction
    ]);
    const pageCatchupComponentProps = {
        contentId: contentId,
        contentType: contentType,
        spaceKey: spaceKey,
        lastVisitedOnDate: lastVisitedOnDate,
        editors: editors,
        ref: catchUpContentRef,
        hideMetadata: hideMetadata,
        versionHistoryLink: versionHistoryLink,
        onVersionHistoryLinkClick: onVersionHistoryLinkClick,
        hasVersionChangedSinceLastVisit: hasVersionChangedSinceLastVisit,
        onShowMoreClick: onShowMoreClick,
        source: source,
        isVersionDiffEmpty: isVersionDiffEmpty,
        isInObjectSidebar: isInObjectSidebar
    };
    const renderPageCatchupComponent = (contentToRender)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $41usS.PageCatchupComponent), {
            ...pageCatchupComponentProps,
            content: contentToRender
        });
    const renderContent = ()=>{
        const isInInlineLinkingExperiment = source !== 'pageHistory' && (0, $6mKj3.expValEqualsNoExposure)('cc_ai_consumption_pc_streaming_inline_linking', 'cohort', 'inline_linking_stream');
        switch(responseState){
            case (0, $ioNzo.AIAgentResponseState).Initialization:
                return isInObjectSidebar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gdv5Z.default), {
                    paddingInline: "space.100"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8LJEA.AISummaryLoading), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $au4KV.AIStreamLoading), null);
            case (0, $ioNzo.AIAgentResponseState).Error:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ly2zj.SmartsSummaryErrorComponent), {
                    analyticsProperties: analyticsProperties,
                    errorFromApolloOrStream: streamSummaryError,
                    contentId: contentId,
                    experienceName: (0, $irVI7.AI_CONTENT_CATCHUP_EXPERIENCE)
                });
            case (0, $ioNzo.AIAgentResponseState).AnswerPart:
                if (isInInlineLinkingExperiment) return renderPageCatchupComponent(inlineLinkingContent);
                return renderPageCatchupComponent(content);
            case (0, $ioNzo.AIAgentResponseState).FinalResponse:
                return renderPageCatchupComponent(content);
            default:
                break;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        className: (0, $35pXk.default)([
            "_ggmhs13h"
        ])
    }, isInObjectSidebar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, metaDataError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: metaDataError
    }), renderContent(), responseState === (0, $ioNzo.AIAgentResponseState).FinalResponse && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.AI_CONTENT_CATCHUP_EXPERIENCE),
        attributes: {
            source: source
        }
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dOOm2.AIBorder), {
        loading: responseState === (0, $ioNzo.AIAgentResponseState).Initialization
    }, metaDataError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: metaDataError
    }), renderContent(), responseState === (0, $ioNzo.AIAgentResponseState).FinalResponse && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.AI_CONTENT_CATCHUP_EXPERIENCE),
        attributes: {
            source: source
        }
    })));
};

});
parcelRegister("jZjxH", function(module, exports) {

$parcel$export(module.exports, "mapInlineLinkingAgentResponseToMarkdown", () => $c393a02d5f46acb0$export$c476676a5dd91e06);
const $c393a02d5f46acb0$export$c476676a5dd91e06 = (responseContent)=>{
    if (!responseContent.response || responseContent.response.length === 0 || responseContent.response.length === 1 && Object.keys(responseContent.response[0]).length === 0) return '';
    return responseContent.response.map((item)=>{
        if ('heading' in item && 'changes' in item) {
            const changes = item.changes && item.changes.length > 0 ? item.changes.map((change)=>{
                let formattedChange = '';
                if (change.change) {
                    formattedChange = `* ${change.change}`;
                    if (change.snippet) formattedChange += ` ${change.snippet}`;
                }
                return formattedChange;
            }).filter(Boolean).join('\n') : '';
            return `### ${item.heading}\n${changes}\n`;
        }
        return '';
    }).join('\n');
};

});

parcelRegister("41usS", function(module, exports) {

$parcel$export(module.exports, "PageCatchupComponent", () => $b47380d9a1361e15$export$c463287b61deee24);
/* PageCatchupComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gUu2y = parcelRequire("gUu2y");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $dcJ7R = parcelRequire("dcJ7R");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $2Pg7f = parcelRequire("2Pg7f");

var $2Nwuj = parcelRequire("2Nwuj");

var $i26zO = parcelRequire("i26zO");
var $fooTI = parcelRequire("fooTI");

var $ly2zj = parcelRequire("ly2zj");

var $k9zyo = parcelRequire("k9zyo");

var $jU1R7 = parcelRequire("jU1R7");
const $b47380d9a1361e15$var$ScrollableBody = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11c81ixg _18m91wug _1suq18uv _1ke8u2gc _155au2gc _aaynm7j4 _1ogl15ej",
            __cmplp.className
        ])
    });
});
const $b47380d9a1361e15$var$HeaderStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.accent.gray.subtlest',
    borderRadius: '4px',
    padding: 'space.100'
});
const $b47380d9a1361e15$var$StackStyles = (0, $ecnYn.xcss)({
    overflowWrap: 'break-word',
    whiteSpace: 'normal',
    height: '100%'
});
const $b47380d9a1361e15$var$ContentStyles = (0, $ecnYn.xcss)({
    gap: 'space.200',
    height: '100%'
});
const $b47380d9a1361e15$var$ContentHeightStyles = (0, $ecnYn.xcss)({
    maxHeight: '350px'
});
const $b47380d9a1361e15$var$FooterObjectSidebarStyles = (0, $ecnYn.xcss)({
    // Object sidebar padding is 16px, this ensures that the footer isn't cutoff by parent padding
    width: 'calc(100% + 32px)',
    marginLeft: 'space.negative.200'
});
const $b47380d9a1361e15$var$i18n = (0, $2nPZH.defineMessages)({
    lastVisitedOn: {
        id: "page-catchup.last-visited-on-text",
        defaultMessage: "Changes since you last visited on {lastVisitedOnDate}."
    },
    firstTimeVisit: {
        id: "page-catchup.first-time-visit-text",
        defaultMessage: "Since this is your first time visiting this content, you\u2019re seeing a page summary instead of a summary of changes."
    },
    noChangesSinceLastVisit: {
        id: "page-catchup.no-changes-since-last-visit-text",
        defaultMessage: "There haven\u2019t been any changes since your last visit on {lastVisitedOnDate}. We\u2019ve generated this summary instead to help refresh your memory."
    },
    fullVersionHistoryLinkText: {
        id: "page-catchup.full.version.history.link.text",
        defaultMessage: "See changes in version history"
    },
    changesBetweenVersionsText: {
        id: "page-catchup.changes.between.versions.text",
        defaultMessage: "Changes between selected versions"
    }
});
const $b47380d9a1361e15$export$c463287b61deee24 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ contentId: contentId, content: content, contentType: contentType, spaceKey: spaceKey, lastVisitedOnDate: lastVisitedOnDate, editors: editors, hideMetadata: hideMetadata, versionHistoryLink: versionHistoryLink, onVersionHistoryLinkClick: onVersionHistoryLinkClick, hasVersionChangedSinceLastVisit: hasVersionChangedSinceLastVisit, onShowMoreClick: onShowMoreClick, source: source, isVersionDiffEmpty: isVersionDiffEmpty, isInObjectSidebar: isInObjectSidebar }, catchUpContentRef)=>{
    const getHeaderText = ()=>{
        if (!hasVersionChangedSinceLastVisit && lastVisitedOnDate) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
            ...$b47380d9a1361e15$var$i18n.noChangesSinceLastVisit,
            values: {
                lastVisitedOnDate: lastVisitedOnDate
            }
        });
        else if (hasVersionChangedSinceLastVisit && lastVisitedOnDate) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
            ...$b47380d9a1361e15$var$i18n.lastVisitedOn,
            values: {
                lastVisitedOnDate: lastVisitedOnDate
            }
        });
        else if (source === 'pageHistory' && !isVersionDiffEmpty) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $b47380d9a1361e15$var$i18n.changesBetweenVersionsText);
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $b47380d9a1361e15$var$i18n.firstTimeVisit);
    };
    if (source === 'pageHistory' && isVersionDiffEmpty) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jU1R7.VersionDiffEmptyComponent), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ly2zj.FeedbackCollectorPropertiesProvider), {
        entrypointId: "d4c9238b-d3d6-4298-83d9-10f6bddd4f2b"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        xcss: $b47380d9a1361e15$var$StackStyles,
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        padding: isInObjectSidebar ? 'space.100' : 'space.200'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        xcss: $b47380d9a1361e15$var$HeaderStyles,
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), null, getHeaderText()), (lastVisitedOnDate && hasVersionChangedSinceLastVisit || source === 'pageHistory') && editors.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Pg7f.default), {
        size: "small",
        data: editors,
        testId: "page-catchup",
        maxCount: 4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $k9zyo.EditorsNameListComponent), {
        editors: editors
    }))), (source !== 'pageHistory' || !isVersionDiffEmpty) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        direction: "column",
        xcss: [
            $b47380d9a1361e15$var$ContentStyles,
            !isInObjectSidebar && $b47380d9a1361e15$var$ContentHeightStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $i26zO.AIContentBlur), {
        shouldOpenInCollapsedView: (!lastVisitedOnDate || !hasVersionChangedSinceLastVisit) && source !== 'pageHistory' && !isInObjectSidebar,
        onShowMore: onShowMoreClick,
        summaryLineHeight: 80
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b47380d9a1361e15$var$ScrollableBody, {
        ref: catchUpContentRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fooTI.AITelepointerWrapper), {
        hideTelepointer: !hideMetadata
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gUu2y.default), null, content))))), versionHistoryLink && !hideMetadata && hasVersionChangedSinceLastVisit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Nwuj.default), {
        href: versionHistoryLink,
        onClick: onVersionHistoryLinkClick,
        target: "_blank"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $b47380d9a1361e15$var$i18n.fullVersionHistoryLinkText)))), !hideMetadata && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: isInObjectSidebar && $b47380d9a1361e15$var$FooterObjectSidebarStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ly2zj.AISummaryFooter), {
        analyticsProperties: {
            source: 'pageCatchup'
        },
        contentId: contentId,
        spaceKey: spaceKey,
        contentType: contentType,
        summaryText: content
    }))));
});

});
parcelRegister("i26zO", function(module, exports) {

$parcel$export(module.exports, "AIContentBlur", () => $2c4cc4d659a0f966$export$4a0c9e9f971c9d4);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $eEA8O = parcelRequire("eEA8O");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $dcJ7R = parcelRequire("dcJ7R");
var $ecnYn = parcelRequire("ecnYn");

var $6fnsQ = parcelRequire("6fnsQ");
const $2c4cc4d659a0f966$var$i18n = (0, $2nPZH.defineMessages)({
    showMore: {
        id: "ai-content-blur.show-more",
        defaultMessage: "Show more"
    }
});
const $2c4cc4d659a0f966$var$BodyStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    position: 'relative'
});
const $2c4cc4d659a0f966$var$BlurStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    background: `linear-gradient( 0deg, ${`var(--ds-surface-overlay, ${(0, $6fnsQ.N10)})`} 0%, ${"var(--ds-background-neutral-subtle, rgba(255, 255, 255, 0))"} 100% )`,
    height: '20px',
    width: '100%'
});
const $2c4cc4d659a0f966$export$4a0c9e9f971c9d4 = ({ children: children, onShowMore: onShowMore, shouldOpenInCollapsedView: shouldOpenInCollapsedView, summaryLineHeight: summaryLineHeight, padding: padding })=>{
    const intl = (0, $dBxQj.default)();
    const [isCollapsed, setIsCollapsed] = (0, $gwFzn.useState)(shouldOpenInCollapsedView);
    const handleShowMoreClick = ()=>{
        if (isCollapsed) {
            setIsCollapsed(false);
            onShowMore?.();
        }
    };
    if (!isCollapsed) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: children
    });
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        testId: "summary-blur-container",
        onClick: handleShowMoreClick,
        style: {
            padding: padding
        },
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $bUlM5.default), {
            alignItems: "end",
            gap: "space.050",
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dcJ7R.default), {
                    grow: "fill",
                    children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
                        xcss: $2c4cc4d659a0f966$var$BodyStyles,
                        style: {
                            maxHeight: summaryLineHeight ? `${summaryLineHeight}px` : '40px'
                        },
                        testId: "child-text-box-container",
                        children: [
                            children,
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                                xcss: $2c4cc4d659a0f966$var$BlurStyles,
                                style: {
                                    top: summaryLineHeight ? `${summaryLineHeight - 20}px` : '20px'
                                },
                                testId: "blur-styles-box-container"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eEA8O.default), {
                    appearance: "link",
                    spacing: "none",
                    children: intl.formatMessage($2c4cc4d659a0f966$var$i18n.showMore)
                })
            ]
        })
    }));
};

});

parcelRegister("k9zyo", function(module, exports) {

$parcel$export(module.exports, "EditorsNameListComponent", () => $f609a69515d1e116$export$d86d70bd36fbdafc);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");
const $f609a69515d1e116$var$i18n = (0, $2nPZH.defineMessages)({
    editorsNameListText: {
        id: "page-catchup.editors.name.list.text",
        defaultMessage: "{editorsCount, plural, one {{firstEditor} has} =2 {{firstEditor} and {secondEditor} have} =3 {{firstEditor}, {secondEditor}, and {thirdEditor} have} other {{firstEditor}, {secondEditor}, {thirdEditor} and {remainingEditorCount} others have}} edited this content"
    },
    editorsNameListTextNoVerbiage: {
        id: "page-catchup.editors.name.list.text.no.verbiage",
        defaultMessage: "{editorsCount, plural, one {{firstEditor}} =2 {{firstEditor} and {secondEditor}} =3 {{firstEditor}, {secondEditor}, and {thirdEditor}} other {{firstEditor}, {secondEditor}, {thirdEditor} and {remainingEditorCount} others}}"
    }
});
const $f609a69515d1e116$export$d86d70bd36fbdafc = ({ editors: editors, showNoVerbiage: showNoVerbiage })=>{
    const editorsCount = editors.length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        testId: "editors-name-list",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        xcss: (0, $ecnYn.xcss)({
            font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        ...showNoVerbiage ? $f609a69515d1e116$var$i18n.editorsNameListTextNoVerbiage : $f609a69515d1e116$var$i18n.editorsNameListText,
        values: {
            editorsCount: editorsCount,
            firstEditor: editorsCount > 0 ? editors[0].name : null,
            secondEditor: editorsCount > 1 ? editors[1].name : null,
            thirdEditor: editorsCount > 2 ? editors[2].name : null,
            remainingEditorCount: editorsCount - 3
        }
    }));
};

});

parcelRegister("jU1R7", function(module, exports) {

$parcel$export(module.exports, "VersionDiffEmptyComponent", () => $01c104751c4671cb$export$2f0d20c33235025e);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $6f0Oj = parcelRequire("6f0Oj");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $63blV = parcelRequire("63blV");
const $01c104751c4671cb$var$footerBoxStyles = (0, $ecnYn.xcss)({
    borderTop: `1px solid ${"var(--ds-border, #091E4224)"}`
});
const $01c104751c4671cb$var$boxTextStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest'
});
const $01c104751c4671cb$var$i18n = (0, $2nPZH.defineMessages)({
    diffEmptyBetweenVersionsText: {
        id: "page-catchup.diff.empty.between.versions.text",
        defaultMessage: "These versions are too similar for Atlassian Intelligence (AI) to generate a summary of the differences between them."
    }
});
const $01c104751c4671cb$export$2f0d20c33235025e = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        padding: "space.250",
        xcss: $01c104751c4671cb$var$boxTextStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $01c104751c4671cb$var$i18n.diffEmptyBetweenVersionsText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        paddingInline: "space.200",
        paddingBlock: "space.050",
        xcss: $01c104751c4671cb$var$footerBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $63blV.AIAttributionFooter), null)));
};

});


parcelRegister("ifEd5", function(module, exports) {

$parcel$export(module.exports, "CatchupContentType", () => $551036f28c08b5b8$export$fe6033382a69eea9);
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $551036f28c08b5b8$export$fe6033382a69eea9 = /*#__PURE__*/ function(CatchupContentType) {
    CatchupContentType["BLOGPOST"] = "BLOGPOST";
    CatchupContentType["PAGE"] = "PAGE";
    return CatchupContentType;
}({});

});

parcelRegister("3nYmf", function(module, exports) {

$parcel$export(module.exports, "mapToEditors", () => $676d15788c30fd82$export$2364cf53dded03dd);
function $676d15788c30fd82$export$2364cf53dded03dd(editors) {
    return editors.map((u)=>{
        return {
            name: u?.displayName ?? '',
            src: u && 'profilePicture' in u ? u?.profilePicture?.path : ''
        };
    });
}

});

parcelRegister("2XwAb", function(module, exports) {

$parcel$export(module.exports, "mapToFormattedDate", () => $b00440823166005e$export$757dbcc1bd42832);
function $b00440823166005e$export$757dbcc1bd42832(ISOdate, locale) {
    if (!ISOdate) return;
    const dateOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    };
    return new Date(ISOdate).toLocaleDateString(locale, dateOptions);
}

});

parcelRegister("555yk", function(module, exports) {

$parcel$export(module.exports, "AI_CONTENT_CATCHUP_INTERACTION_METRIC", () => $f249c720b72bd2f9$export$42c905138efbcdac);

var $jIOyV = parcelRequire("jIOyV");
var $lSOAM = parcelRequire("lSOAM");
const $f249c720b72bd2f9$export$42c905138efbcdac = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.AI_CONTENT_CATCHUP_INTERACTION)
});

});

parcelRegister("5HlWa", function(module, exports) {

$parcel$export(module.exports, "useGetVersionHistoryLink", () => $dbb424c9806aaca2$export$3042bbbffe78f13c);

var $dPJCf = parcelRequire("dPJCf");

var $1NBp8 = parcelRequire("1NBp8");
var $jlIaF = parcelRequire("jlIaF");
const $dbb424c9806aaca2$var$usePrevVersionParam = (0, $dPJCf.createSingleQueryParamHook)('prevVersion');
const $dbb424c9806aaca2$var$useCurrentVersionParam = (0, $dPJCf.createSingleQueryParamHook)('currVersion');
const $dbb424c9806aaca2$export$3042bbbffe78f13c = (contentId, spaceKey, pageVersion)=>{
    const fallbackLink = (0, $1NBp8.CONTENT_HISTORY).toUrl({
        spaceKey: spaceKey,
        contentId: contentId
    });
    const prevVersionFromParam = parseInt($dbb424c9806aaca2$var$usePrevVersionParam() ?? '');
    const currVersionFromParam = parseInt($dbb424c9806aaca2$var$useCurrentVersionParam() ?? '');
    if (pageVersion < 0 && (isNaN(currVersionFromParam) || isNaN(prevVersionFromParam))) return {
        versionHistoryLink: fallbackLink
    };
    const currVersion = isNaN(currVersionFromParam) ? pageVersion : currVersionFromParam;
    const prevVersion = isNaN(prevVersionFromParam) ? pageVersion - 1 : prevVersionFromParam;
    const versionDiffLink = `${(0, $jlIaF.CONTEXT_PATH)}/pages/diffpagesbyversion.action?pageId=${contentId}&selectedPageVersions=${prevVersion}&selectedPageVersions=${currVersion}`;
    return {
        versionHistoryLink: versionDiffLink
    };
};

});


parcelRegister("a9eQ6", function(module, exports) {

$parcel$export(module.exports, "PageCatchupVersionDiffWrapperComponent", () => $9aed974a19335374$export$64a71206cb6a93be);
/* PageCatchupVersionDiffWrapperComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @graphql cc
 */ 
var $35pXk = parcelRequire("35pXk");

var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $diswb = parcelRequire("diswb");

var $kyKWe = parcelRequire("kyKWe");

var $inPa6 = parcelRequire("inPa6");

var $gdv5Z = parcelRequire("gdv5Z");

var $3j1mV = parcelRequire("3j1mV");

var $fXbFR = parcelRequire("fXbFR");

var $fYQcF = parcelRequire("fYQcF");

var $dOOm2 = parcelRequire("dOOm2");
var $au4KV = parcelRequire("au4KV");
var $8LJEA = parcelRequire("8LJEA");

var $kAaxz = parcelRequire("kAaxz");
var $d3UlG = parcelRequire("d3UlG");

var $ly2zj = parcelRequire("ly2zj");

var $bQm3c = parcelRequire("bQm3c");

var $dIouf = parcelRequire("dIouf");

var $irVI7 = parcelRequire("irVI7");
var $1eaCJ = parcelRequire("1eaCJ");
var $1kHsc = parcelRequire("1kHsc");

var $dPJCf = parcelRequire("dPJCf");

var $41usS = parcelRequire("41usS");

var $ifEd5 = parcelRequire("ifEd5");

var $3nYmf = parcelRequire("3nYmf");

var $2XwAb = parcelRequire("2XwAb");

var $555yk = parcelRequire("555yk");

var $5HlWa = parcelRequire("5HlWa");

var $5cgqG = parcelRequire("5cgqG");
const $9aed974a19335374$var$PageCatchupVersionDiffWrapperComponentPageCatchupMetadataQuery = (0, $d2LG0.default)`query PageCatchupVersionDiffWrapperComponentPageCatchupMetadataQuery($contentId:ID!$contentType:CatchupContentType!$endTimeMs:Long!){catchupEditMetadataForContent(contentId:$contentId contentType:$contentType endTimeMs:$endTimeMs){lastVisitTimeISO hasVersionChangedSinceLastVisit users{displayName profilePicture{path}}}content(id:$contentId){nodes{version{number}}}}`;
const $9aed974a19335374$var$PageCatchupVersionDiffWrapperComponentPageCatchupVersionDiffMetadataForContentQuery = (0, $d2LG0.default)`query PageCatchupVersionDiffWrapperComponentPageCatchupVersionDiffMetadataForContentQuery($contentId:ID!$contentType:CatchupContentType!$originalContentVersion:Int!$revisedContentVersion:Int!){catchupVersionDiffMetadataForContent(contentId:$contentId contentType:$contentType originalContentVersion:$originalContentVersion revisedContentVersion:$revisedContentVersion){isDiffEmpty users{displayName profilePicture{height isDefault width path}}}}`;
const $9aed974a19335374$var$useOpenContentCatchupParam = (0, $dPJCf.createSingleQueryParamHook)('openContentCatchup');
const $9aed974a19335374$var$styles = null;
const $9aed974a19335374$export$64a71206cb6a93be = ({ contentId: contentId, contentType: contentType, spaceKey: spaceKey, source: source, selectedVersions: selectedVersions, isInObjectSidebar: isInObjectSidebar })=>{
    const { locale: locale } = (0, $dBxQj.default)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { pageAri: pageAri } = (0, $3j1mV.useConfluencePageAri)(cloudId, contentId, contentType);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [aiInteractionId] = (0, $gwFzn.useState)((0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))());
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const catchUpContentRef = (0, $gwFzn.useRef)(null);
    const { getDwellTime: getDwellTime } = (0, $fXbFR.usePopupDwellTime)(catchUpContentRef);
    const [dateInMs] = (0, $gwFzn.useState)(Date.now());
    const [hideMetadata, setHideMetadata] = (0, $gwFzn.useState)(true);
    const analyticsProperties = {
        source: 'pageCatchup',
        additionalAnalyticsAttributes: {
            subSource: source
        }
    };
    const originalContentVersion = selectedVersions ? Math.min(...Array.from(selectedVersions)) : 0;
    const revisedContentVersion = selectedVersions ? Math.max(...Array.from(selectedVersions)) : 0;
    const hasSelectedVersions = selectedVersions && selectedVersions.size > 1 && source === 'pageHistory';
    const isStreamingDone = (0, $gwFzn.useRef)(false);
    const isStreamInitializationDone = (0, $gwFzn.useRef)(false);
    const timeToFirstAnswerPart = (0, $gwFzn.useRef)(0);
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultView: trackAIResultView, trackAIResultError: trackAIResultError, trackAIResultAction: trackAIResultAction, trackAIInteractionDismiss: trackAIInteractionDismiss } = (0, $fYQcF.useAIEventsInstrumentation)();
    const hasQueryParamOpenSet = $9aed974a19335374$var$useOpenContentCatchupParam() === 'true';
    const contentTypeEnum = contentType === 'page' ? (0, $ifEd5.CatchupContentType).PAGE : (0, $ifEd5.CatchupContentType).BLOGPOST;
    const { data: data, error: defaultMetaDataError } = (0, $diswb.useQuery)($9aed974a19335374$var$PageCatchupVersionDiffWrapperComponentPageCatchupMetadataQuery, {
        variables: {
            contentId: contentId,
            contentType: contentTypeEnum,
            endTimeMs: dateInMs
        },
        skip: hasSelectedVersions
    });
    const { data: versionDiffMetadata, error: versionDiffMetadataError } = (0, $diswb.useQuery)($9aed974a19335374$var$PageCatchupVersionDiffWrapperComponentPageCatchupVersionDiffMetadataForContentQuery, {
        variables: {
            contentId: contentId,
            contentType: contentTypeEnum,
            originalContentVersion: originalContentVersion,
            revisedContentVersion: revisedContentVersion
        },
        skip: !hasSelectedVersions
    });
    const metaDataError = defaultMetaDataError || versionDiffMetadataError;
    const isVersionDiffEmpty = versionDiffMetadata?.catchupVersionDiffMetadataForContent?.isDiffEmpty ?? false;
    const versionDiffUsers = versionDiffMetadata?.catchupVersionDiffMetadataForContent?.users ?? [];
    const versionDiffEditors = (0, $3nYmf.mapToEditors)(versionDiffUsers);
    const setIsStreamingDone = ()=>{
        isStreamingDone.current = true;
    };
    const setIsStreamInitializationDone = ()=>{
        isStreamInitializationDone.current = true;
    };
    const onShowMoreClick = (0, $gwFzn.useCallback)(()=>{
        trackAIResultAction('showMoreClicked');
    }, [
        trackAIResultAction
    ]);
    const [request, config] = (0, $gwFzn.useMemo)(()=>(0, $5cgqG.buildCatchupRequest)({
            contentAri: pageAri ?? '',
            locale: locale,
            updateType: 'BETWEEN_VERSIONS',
            endTimeMs: dateInMs,
            selectedVersions: selectedVersions
        }), [
        pageAri,
        locale,
        dateInMs,
        selectedVersions
    ]);
    const onStateChange = (0, $gwFzn.useCallback)((state)=>{
        switch(state.responseState){
            case (0, $kAaxz.ConvoAIResponseState).Initialization:
                if (state.content === null) {
                    experienceTracker.start({
                        name: (0, $irVI7.AI_CONTENT_CATCHUP_EXPERIENCE)
                    });
                    (0, $555yk.AI_CONTENT_CATCHUP_INTERACTION_METRIC).start();
                    trackAIInteractionInit();
                    timeToFirstAnswerPart.current = Date.now();
                }
                break;
            case (0, $kAaxz.ConvoAIResponseState).Error:
                const { status_code: status_code, message_template: message_template } = state.error.message;
                (0, $555yk.AI_CONTENT_CATCHUP_INTERACTION_METRIC).stop();
                trackAIResultError({
                    aiErrorCode: status_code,
                    aiErrorMessage: message_template
                });
                setIsStreamingDone();
                break;
            case (0, $kAaxz.ConvoAIResponseState).AnswerPart:
                if (!isStreamInitializationDone.current) {
                    setIsStreamInitializationDone();
                    createAnalyticsEvent({
                        type: 'sendTrackEvent',
                        data: {
                            action: 'streamReceived',
                            actionSubject: 'pageCatchup',
                            source: source ?? 'page',
                            actionSubjectId: 'pageCatchupDialog',
                            attributes: {
                                contentId: contentId,
                                timeToFirstAnswerPartInMs: Date.now() - timeToFirstAnswerPart.current
                            }
                        }
                    }).fire();
                }
                break;
            case (0, $kAaxz.ConvoAIResponseState).FinalResponse:
                (0, $555yk.AI_CONTENT_CATCHUP_INTERACTION_METRIC).stop();
                createAnalyticsEvent({
                    type: 'sendScreenEvent',
                    data: {
                        name: 'pageCatchupDialog',
                        attributes: {
                            contentId: contentId,
                            aiInteractionId: aiInteractionId,
                            hasQueryParamOpenSet: hasQueryParamOpenSet
                        }
                    }
                }).fire();
                trackAIResultView();
                setIsStreamingDone();
                break;
            default:
                break;
        }
    }, [
        trackAIResultError,
        createAnalyticsEvent,
        contentId,
        aiInteractionId,
        hasQueryParamOpenSet,
        trackAIResultView,
        experienceTracker,
        trackAIInteractionInit,
        source
    ]);
    const [{ content: content, responseState: responseState, error: streamSummaryError }] = (0, $d3UlG.useConvoAIStreaming)(request, config, onStateChange);
    (0, $gwFzn.useEffect)(()=>{
        return ()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'dwelled',
                    actionSubject: 'pageCatchup',
                    source: source ?? 'page',
                    actionSubjectId: 'pageCatchupDialog',
                    attributes: {
                        contentId: contentId,
                        dwellTime: getDwellTime(),
                        aiInteractionId: aiInteractionId,
                        hasQueryParamOpenSet: hasQueryParamOpenSet
                    }
                }
            }).fire();
            if (!isStreamInitializationDone.current) trackAIInteractionDismiss({
                attributes: {
                    dismissTiming: 'stream_initialization'
                }
            });
            else if (!isStreamingDone.current) trackAIInteractionDismiss({
                attributes: {
                    dismissTiming: 'answer_part_streaming'
                }
            });
        }; // we only want to run this effect on un-mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $gwFzn.useEffect)(()=>{
        if (responseState === (0, $kAaxz.ConvoAIResponseState).FinalResponse) {
            if (hideMetadata) setHideMetadata(false);
        }
    }, [
        responseState,
        hideMetadata
    ]);
    const lastVisitedOnDate = (0, $2XwAb.mapToFormattedDate)(data?.catchupEditMetadataForContent?.lastVisitTimeISO, locale);
    const hasVersionChangedSinceLastVisit = data?.catchupEditMetadataForContent?.hasVersionChangedSinceLastVisit ?? false;
    const users = data?.catchupEditMetadataForContent?.users ?? [];
    const defaultEditors = (0, $3nYmf.mapToEditors)(users);
    const editors = source === 'pageHistory' ? versionDiffEditors : defaultEditors;
    const pageVersion = data?.content?.nodes?.[0]?.version?.number ?? -1;
    const { versionHistoryLink: versionHistoryLink } = (0, $5HlWa.useGetVersionHistoryLink)(contentId, spaceKey, pageVersion);
    const onVersionHistoryLinkClick = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'pageCatchup',
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: 'pageCatchupVersionHistoryLink',
                attributes: {
                    contentId: contentId,
                    aiInteractionId: aiInteractionId,
                    hasQueryParamOpenSet: hasQueryParamOpenSet
                }
            }
        }).fire();
        trackAIResultAction('versionHistoryLinkClick');
    }, [
        contentId,
        createAnalyticsEvent,
        aiInteractionId,
        hasQueryParamOpenSet,
        trackAIResultAction
    ]);
    const pageCatchupComponentProps = {
        contentId: contentId,
        contentType: contentType,
        spaceKey: spaceKey,
        lastVisitedOnDate: lastVisitedOnDate,
        editors: editors,
        ref: catchUpContentRef,
        hideMetadata: hideMetadata,
        versionHistoryLink: versionHistoryLink,
        onVersionHistoryLinkClick: onVersionHistoryLinkClick,
        hasVersionChangedSinceLastVisit: hasVersionChangedSinceLastVisit,
        onShowMoreClick: onShowMoreClick,
        source: source,
        isVersionDiffEmpty: isVersionDiffEmpty,
        isInObjectSidebar: isInObjectSidebar
    };
    const renderPageCatchupComponent = (contentToRender)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $41usS.PageCatchupComponent), {
            ...pageCatchupComponentProps,
            content: contentToRender
        });
    const renderContent = ()=>{
        switch(responseState){
            case (0, $kAaxz.ConvoAIResponseState).Initialization:
                return isInObjectSidebar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gdv5Z.default), {
                    paddingInline: "space.100"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8LJEA.AISummaryLoading), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $au4KV.AIStreamLoading), null);
            case (0, $kAaxz.ConvoAIResponseState).Error:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ly2zj.SmartsSummaryErrorComponent), {
                    analyticsProperties: analyticsProperties,
                    errorFromApolloOrStream: streamSummaryError,
                    contentId: contentId,
                    experienceName: (0, $irVI7.AI_CONTENT_CATCHUP_EXPERIENCE)
                });
            case (0, $kAaxz.ConvoAIResponseState).AnswerPart:
            case (0, $kAaxz.ConvoAIResponseState).FinalResponse:
                return renderPageCatchupComponent(content);
            default:
                break;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        className: (0, $35pXk.default)([
            "_4t3i1osq _ggmhs13h"
        ])
    }, isInObjectSidebar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, metaDataError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: metaDataError
    }), renderContent(), responseState === (0, $kAaxz.ConvoAIResponseState).FinalResponse && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.AI_CONTENT_CATCHUP_EXPERIENCE),
        attributes: {
            source: source
        }
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dOOm2.AIBorder), {
        loading: responseState === (0, $kAaxz.ConvoAIResponseState).Initialization
    }, metaDataError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: metaDataError
    }), renderContent(), responseState === (0, $kAaxz.ConvoAIResponseState).FinalResponse && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.AI_CONTENT_CATCHUP_EXPERIENCE),
        attributes: {
            source: source
        }
    })));
};

});
parcelRegister("5cgqG", function(module, exports) {

$parcel$export(module.exports, "buildCatchupRequest", () => $9ed1632df7d8fede$export$60847e9d6d4c2441);
const $9ed1632df7d8fede$export$60847e9d6d4c2441 = ({ contentAri: contentAri, locale: locale, updateType: updateType, endTimeMs: endTimeMs, selectedVersions: selectedVersions, enablePartialJson: enablePartialJson = false })=>{
    return [
        {
            ai_feature_input: {
                content_ari: contentAri,
                locale: locale,
                update_type: updateType,
                end_time_ms: endTimeMs,
                ...selectedVersions && {
                    original_content_version: Math.min(...Array.from(selectedVersions)),
                    revised_content_version: Math.max(...Array.from(selectedVersions))
                }
            }
        },
        {
            apiPath: 'v2/ai-feature/confluence-content-catchup',
            delayChunkUpdate: {
                gap: 10,
                time: 20
            },
            enablePartialJson: enablePartialJson,
            headers: {
                'x-experience-id': 'catchup-version-summary',
                'x-product': 'confluence'
            }
        }
    ];
};

});



parcelRegister("kBab3", function(module, exports) {

$parcel$export(module.exports, "usePageCatchupQueryParamOpen", () => $619d61f42437d205$export$a82675333a170ad7);

var $gwFzn = parcelRequire("gwFzn");

var $dPJCf = parcelRequire("dPJCf");
const $619d61f42437d205$var$useOpenPageCatchupParam = (0, $dPJCf.createSingleQueryParamHook)('openContentCatchup');
const $619d61f42437d205$export$a82675333a170ad7 = (isOpen, setIsOpen, selectedVersions)=>{
    const [hasSeen, setHasSeen] = (0, $gwFzn.useState)(false);
    const isOpenPageCatchupQueryParamValid = $619d61f42437d205$var$useOpenPageCatchupParam() === 'true';
    const hasSelectedVersions = selectedVersions && selectedVersions.size > 1;
    (0, $gwFzn.useEffect)(()=>{
        if (!isOpen && isOpenPageCatchupQueryParamValid && !hasSeen && hasSelectedVersions) {
            setIsOpen(true);
            setHasSeen(true);
        }
    }, [
        isOpen,
        setIsOpen,
        isOpenPageCatchupQueryParamValid,
        hasSeen,
        setHasSeen,
        hasSelectedVersions
    ]);
};

});


parcelRegister("86vQj", function(module, exports) {

$parcel$export(module.exports, "PageCatchupPopupForPageHistory", () => $331fad0aae4cd917$export$9321895a4e785c58);

var $gwFzn = parcelRequire("gwFzn");

var $bQm3c = parcelRequire("bQm3c");

var $9wGTI = parcelRequire("9wGTI");

var $gL2Cx = parcelRequire("gL2Cx");
const $331fad0aae4cd917$export$9321895a4e785c58 = ({ contentId: contentId, contentType: contentType, spaceKey: spaceKey, source: source, selectedVersions: selectedVersions })=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const isDisabled = selectedVersions.size < 2;
    const shouldRenderPageCatchupPopup = isAdminHubAIEnabled && (0, $9wGTI.fg)('cc_ai_consumption_page_catchup_in_page_history');
    if (shouldRenderPageCatchupPopup) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gL2Cx.PageCatchupPopupComponent), {
        contentId: contentId,
        contentType: contentType,
        spaceKey: spaceKey ?? '',
        isDisabled: isDisabled,
        source: source,
        selectedVersions: selectedVersions
    });
    return null;
};

});



//# sourceMappingURL=ObjectSidebarControl.0438e03c.js.map
